import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import { Notice } from 'model/notice';
import React, { useEffect, useState } from 'react';

export default function useNotice() {
  const {
    getQuery: { data },
  } = useQuery<PageNationV2Response<Notice>>(API_PATH.ANNOUNCEMENT);

  return { data };
}
